import { c as _c } from "react/compiler-runtime";
import { ButtonHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';
type SizeButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
  selected?: boolean;
  disabled?: boolean;
  error?: boolean;
  children?: ReactNode;
};
export const SizeButton = t0 => {
  const $ = _c(18);
  let children;
  let className;
  let disabled;
  let error;
  let rest;
  let selected;
  if ($[0] !== t0) {
    ({
      className,
      selected,
      disabled,
      error,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = error;
    $[5] = rest;
    $[6] = selected;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    error = $[4];
    rest = $[5];
    selected = $[6];
  }
  const t1 = selected ? "bg-black text-white" : "bg-white text-black";
  const t2 = disabled ? "pointer-events-none border border-neutral-600 text-neutral-600 opacity-50" : "";
  const t3 = error ? "border-red-600 text-red-600" : "";
  let t4;
  if ($[7] !== className || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = clsx("flex cursor-pointer items-center justify-center border-2 border-black px-4 py-2 text-center text-sm font-semibold", "hover:border-neutral-900 hover:bg-neutral-900 hover:text-white", "focus-visible:shadow-[0_0_0_2px_var(--white)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus aria-disabled:pointer-events-none aria-disabled:opacity-50", t1, t2, t3, className);
    $[7] = className;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== children || $[13] !== disabled || $[14] !== rest || $[15] !== selected || $[16] !== t4) {
    t5 = <button className={t4} role="option" aria-disabled={disabled} aria-selected={selected} {...rest}>{children}</button>;
    $[12] = children;
    $[13] = disabled;
    $[14] = rest;
    $[15] = selected;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};